module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/tachikawa_sns_06-dcbe65607ee814ec30756e6e91a0d447.jpg";